import { useCubeQuery } from '@cubejs-client/react';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { NumberFormatPreset } from '@procureai/ui-mui';
import { isNil } from 'ramda';

import { CurrencyCell, NumberCell } from '~/components/DataGridCustom';
import { DEFAULT_DATE_RANGE } from '~/components/DateRangeProvider/DateRangeProvider.util';
import { convertDateRangeToTimeDimension, getSegments } from '~/util/cube';

export type SupplierMetricsCellValue = { supplierId: string; variant: 'COUNT' | 'VOLUME' };

interface PSupplierMetricsCellProps<R extends GridValidRowModel = any> {
  value: SupplierMetricsCellValue;
  row: R;
}
const CUBE = 'MonthlyOrderFacts';

const MEASURE = {
  COUNT: `${CUBE}.monthly_placed_orders`,
  VOLUME: `${CUBE}.monthly_order_volume`,
};

export const SupplierMetricsCell = <R extends GridValidRowModel = any>({ value }: PSupplierMetricsCellProps<R>) => {
  const orderVolumeSeries = useCubeQuery({
    measures: [MEASURE[value.variant]],
    filters: [
      {
        member: `${CUBE}.supplierId`,
        operator: 'equals',
        values: [value?.supplierId],
      },
    ],
    timeDimensions: convertDateRangeToTimeDimension(`${CUBE}.date`, DEFAULT_DATE_RANGE, 'month'),
  });
  const { totalValue } = getSegments(orderVolumeSeries);

  if (isNil(totalValue)) {
    return null;
  }

  if (value.variant === 'COUNT') {
    return <NumberCell value={totalValue} preset={NumberFormatPreset.INTEGER} />;
  }
  return <CurrencyCell value={totalValue} />;
};
